import React, { Component } from "react";
// import Draggable, { DraggableCore } from "react-draggable";
import { UncontrolledTooltip, Badge } from "reactstrap";
class TextAreaCustom extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      ttid: "TTID" + String(Math.round(Math.random() * 1000000000)),
      ttid2: "TTID" + String(Math.round(Math.random() * 1000000000))
    };
  }

  handleChange(e) {
    let x = this.props.parentState.errorMessages;
    x[this.props.component.name] = "";
    this.props.liftGlobalState({ name: "errorMessages" }, x);
    this.props.liftState(this.props.component, e.target.value);
  }



  componentDidMount() {
    let { fileFolder, formState, modalname, pageData } = this.props.parentState;
    let { name, displayData, defaultValue } = this.props.component;
    if (
      pageData && !fileFolder.isOpen &&
      ((!modalname && !pageData[name]) || (modalname && ( !pageData[modalname] || !pageData[modalname][name]) )) &&
      defaultValue
    ) {
      this.props.liftState(this.props.component, defaultValue);
    }
  }
  generateID() {
    return this.state.ttid;
  }
  generateID2() {
    return this.state.ttid2;
  }

  render() {
    let textType = "text";
    
    if (this.props.component.validation) {
      textType = this.props.component.validation;
    }
    
    let {conditionalRender}=this.props;
    const { name, label, placeHolder, description,isReadOnly } = this.props.component;
    let {currentPage,formElements,formState,fileFolder,openmodals,pageData,errorMessages}=this.props.parentState;
    let isReadOnly1 = false;    
    if ( (pageData.unique_id && isReadOnly == 'edit') || (conditionalRender && conditionalRender == 'readonly') || (isReadOnly && isReadOnly!='edit') ) {
      isReadOnly1 = true;
    }
    let boxvalue;
      let modalname=openmodals[openmodals.length-1];
      if(modalname && pageData[modalname]){
        boxvalue = pageData[modalname][name]
        ? pageData[modalname][name]
        : "";
      }else{
        boxvalue = pageData[name]
        ? pageData[name]
        : "";
      }
    const tooltipID = this.generateID();
    const tooltipID2 = this.generateID2();
    let currentError;
    if (errorMessages) {
      if (modalname && errorMessages[modalname] && errorMessages[modalname][name]) {
        currentError = errorMessages[modalname][name];
      } else if (!modalname && errorMessages[name]) {
        currentError = errorMessages[name];
      }
    }

    return (
      <div className={`form-group   ${this.props.component.widths.parent}`}>
        {label &&
          label != "" && (
            <span>
              <label
               
                className="col-form-label col-form-label-sm nopadding"
              >
                {label}
              </label>
              
            </span>
          )}
        {" " + this.props.parentState.errorMessages != undefined &&
        this.props.parentState.errorMessages[name] ? (
          <span>
            
          </span>
        ) : (
          ""
        )}
        {conditionalRender && conditionalRender!='blank' && 
        <div className="input-group input-group-sm">
          {this.props.component.prepend && (
            <div className="input-group-prepend">
              <div className="input-group-text">
                {this.props.component.prepend}
              </div>
            </div>
          )}
          <textarea
            aria-label={label}
            
            className={`col-12 form-control form-control-sm primary ${
              currentError
                ? "validationErrorBox"
                : ""
            }`}
            autoComplete="off"
            readOnly={isReadOnly1}
            name={name}
            placeholder={placeHolder}
            value={boxvalue}
            onChange={this.handleChange}
          />

          {this.props.component.append && (
            <div className="input-group-append">
              <div className="input-group-text">
                {this.props.component.append}
              </div>
            </div>
          )}
        </div>
        }
      </div>
    );
  }
}

export default TextAreaCustom;
